import { Component, Input, Output, EventEmitter } from '@angular/core';
import { App, LoadingController, NavControllerBase, NavController } from 'ionic-angular';
import { EventTievts, EventProvider, EventComplex, EventDetailsModel } from '../../providers/event/event';
import { TranslateService } from '@ngx-translate/core';
import { ResultProvider } from '../../providers/result/result';
import { ResultRanglistPage } from '../../pages/results/result-ranglist/result-ranglist';
import { EventTabsPage } from '../../pages/event/details/event-tabs/event-tabs';
import { ResultEventDetailsPage } from '../../pages/results/result-event-details/result-event-details';

/**
 * Generated class for the MysportIconComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */

@Component({
    selector: 'menu-layer-category',
    templateUrl: 'menu-layer-category.html'
})
export class MenuLayerCategoryComponent {
    currentPage = Array(15).fill(0);
    EVENTS_PER_PAGE = 5;
    eventsComplex = [];

    @Input("eventType")
    eventType: string;

    @Input("type")
    type: string = "Events";

    @Output() getTotalEvents = new EventEmitter<string>();

    constructor(
        public app: App,
        private loadingCtrl: LoadingController,
        private translate: TranslateService,
        private eventService: EventProvider,
        private resultService: ResultProvider) {
        console.log('MENU LAYER CATEGORY');
    }

    getEventStatus(event: EventTievts) {
        let status = event.eventStatus;
        if (status.toUpperCase().includes("CANCELLED")) return this.translate.instant('EVENT_CANCELLED');
        else if (status.toUpperCase().includes("NOT_CONFIRMED")) return this.translate.instant('NOT_CONFIRMED');
        else return "";
    }

    ngAfterViewInit() {
        console.log('MENU LAYER CATEGORY');
        var loader = this.loadingCtrl.create({ content: this.translate.instant('GLOBAL_LOADING') });
        loader.present();

        this.eventService.getResultsCategoryComplex(this.resultService.getResultTypeAPIName(this.eventType, this.type)).then((datas: EventComplex[]) => {
            this.eventsComplex = Object.assign([], datas);
            loader.dismiss();
        });
    }

    onEventLoad(event) {
        console.log('this.type: ', this.type);
        if (this.type === "Events") this.openEventDetails(event);
        else this.onShowRangList(event);
    }

    openEventDetails(_event) {
        let loader = this.loadingCtrl.create({ content: this.translate.instant('GLOBAL_LOADING') });
        loader.present();
        this.eventService.getEventId(_event.eventName, _event.ort, _event.dateFormatted, _event.cid).then(id => {
            if (id == -1) { loader.dismiss(); return; };

            this.eventService.getEventDetails(id).then((event: EventDetailsModel) => {

                if (event.name.length < 1) {
                    this.openEventDetails(_event);
                    loader.dismiss();
                } else {
                    (this.app.getRootNav() as NavController).push(EventTabsPage, { event: event }).then(() => loader.dismiss());
                }
            });
        })
    }

    onShowRangList(event) {
        let loader = this.loadingCtrl.create({ content: this.translate.instant('GLOBAL_LOADING') });
        loader.present();

        this.eventService.getEventId(event.eventName, event.ort, event.dateFormatted, event.cid).then(id => {

            let searchModel = { eid: '' + id, ename: '' + event.eventName, limit: 25 + '', page: 1 + '', start: 0 + '' };

            (this.app.getRootNav() as NavController).push(ResultEventDetailsPage, { eventDetails: event, search: searchModel })
                .then(() => loader.dismiss());
        });
    }

    onMorePress(i: number) {
        this.getTotalEvents.emit(this.eventsComplex[i].category);
    }

    isFirstPage(i: number): boolean {
        return (this.currentPage[i] == 0) ? true : false;
    }

    isLastPage(n: number, i: number): boolean {
        return ((this.currentPage[i] + 1) > (n / this.EVENTS_PER_PAGE)) ? true : false;
    }

    nextPage(i: number) {
        this.currentPage[i]++;
    }

    prevPage(i: number) {
        this.currentPage[i]--;
    }

    arrayOf(events: EventTievts[], i: number): EventTievts[] {
        if (events.length == 0)
            return null;

        if (this.isLastPage(events.length, i)) {
            return events.slice(this.currentPage[i] * this.EVENTS_PER_PAGE, (this.currentPage[i] * this.EVENTS_PER_PAGE) + (events.length % this.EVENTS_PER_PAGE));
        }
        return events.slice(this.currentPage[i] * this.EVENTS_PER_PAGE, (this.currentPage[i] + 1) * this.EVENTS_PER_PAGE);
    }

}



// WEBPACK FOOTER //
// /src/components/menu-layer-category/menu-layer-category.ts